import { render, staticRenderFns } from "./project-phases.html?vue&type=template&id=bd938bae&"
import script from "./ProjectPhases.vue?vue&type=script&lang=js&"
export * from "./ProjectPhases.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPhases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports